import { ElMessage,ElMessageBox,ElLoading } from 'element-plus'; // 引入 Element UI 的加载服务
import { config } from "@/config/setting";
import { storage } from "@/utils/storage";


//封装简易的弹出提示
const showMsg = (msg, type = 'success') => {
  ElMessage({
    message: msg,
    type: type,
  });
};

//消息弹出框
const showMsgBox = (msg, type = 'warning') => {
  ElMessageBox.alert(msg, type, {
    confirmButtonText: '确定',
    type: type,
  });
};

//确认框
const showConfirmBox = (title="是否确认~",message="是否确认该操作？", type = 'warning', callback) => {
    ElMessageBox.confirm(title, {
        title: title,
        message: message,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: type,
    }).then(() => {
        // 用户点击确定按钮后的处理逻辑
        if (callback) {
            callback(true);
        }
    }).catch(() => {
        // 用户点击取消按钮后的处理逻辑
        if (callback) {
            callback(false);
        }
    });
};


//获取用户数据
const getUserInfo = () => {
   return storage.get(config.userInfoKey);
}

//获取用户id
const getUserId = () => {
    const userInfo = getUserInfo();
    return userInfo ? userInfo.id : null;
}

//获取用户token
const getToken = () => {
    return storage.get(config.tokenKey);
}

//等待几秒跳转 vue 路由形式
export const waitJump = (url, time = 2000) => {
    // 显示加载框
    const loading = ElLoading.service({
        text: '正在跳转中...',
        background: 'rgba(0, 0, 0, 0.7)',
    });

    setTimeout(() => {
        loading.close(); // 关闭加载框
        if (window.app && window.app.$router) {
            window.app.$router.push(url); // 跳转到指定 URL
        } else {
            console.error('Vue app or router is not initialized yet.');
        }
    }, time);
};

//获取日期区间 输入数字即可输出 开始和结束两个日期 不包含时分秒
export const getDateRange = (days) => {
    const endDate = new Date();
    const startDate = new Date(endDate.getTime() - days * 24 * 60 * 60 * 1000);
    return [getDateFormat(startDate), getDateFormat(endDate)];
}

//获取指定日期格式 输入时间戳 输出日期格式
export const getDateFormat = (timestamp) => {
    const date = new Date(timestamp);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

//输入时间戳 输入 带有 时分秒的日期
export const getDateFormatWithTime = (timestamp) => {
    const date = new Date(timestamp);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

//根据用户标识检测是否可以进行删除操作
export const isDelAuth = ()=>{
    //获取用户基本数据
    const userInfo = getUserInfo();
    //获取权限标识 ROLE
    return userInfo.role === 'ADMIN' || userInfo.role === 'SUPER_ADMIN';
}

//复制剪切板
export const copyToClipboard = (text) => {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';  // 防止滚动时影响页面布局
    textArea.style.left = '-9999px';
    textArea.style.top = '-9999px';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
        const successful = document.execCommand('copy');
        if (successful) {
            showMsg('复制完毕', 'success');
        } else {
            showMsg('复制失败', 'error');
        }
    } catch (err) {
        console.error('无法执行复制命令: ', err);
        showMsg('复制失败', 'error');
    }

    document.body.removeChild(textArea);
};

//获取当前的年月日时分秒 使用数字进行无日期格式
export const getCurrentDateTime = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    return `${year}${month}${day}${hours}${minutes}${seconds}`;
}

//外部调用
export const helper = {
    showMsg,
    showMsgBox,
    showConfirmBox,
    getUserInfo,
    waitJump,
    getUserId,
    getDateRange,
    getDateFormat,
    getDateFormatWithTime,
    isDelAuth,
    getToken,
    copyToClipboard,
    getCurrentDateTime
}
